export const sliderItemStyles = {
  xs: {
    container: {
      paddingY: "5px",
      border: "0.32px solid #90929980"
    },
    icon: {
      width: "7px",
      height: "7px"
    },
    label: {
      fontSize: "0.25rem !important"
    }
  },
  lg: {
    container: {
      paddingY: "7px",
      border: "1px solid ##90929980"
    },
    icon: {
      width: "12px",
      height: "12px"
    },
    label: {
      fontSize: "0.4rem !important"
    }
  },
  xl: {
    container: {
      paddingY: "10px",
      border: "1px solid ##90929980"
    },
    icon: {
      width: "18px",
      height: "18px"
    },
    label: {
      fontSize: "0.625rem !important"
    }
  }
}